import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PayAccessorv7chehvo6140 as PayAccessor,
  IClairSdkAppKeyProvider1y5oia2cqp2x4 as IClairSdkAppKeyProvider,
} from './Shared7Punches-data-pay.mjs';
import { IFeatureFlagEvaluatorscidb4c0cp4 as IFeatureFlagEvaluator } from './Shared7Punches-infrastructure-featureflag.mjs';
import { IEnvironmentProvider2spq4fpbokmem as IEnvironmentProvider } from './Shared7Punches-common-base.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IResolveClairExperienceUseCase, 'IResolveClairExperienceUseCase', VOID, VOID, VOID, [0]);
initMetadataForClass(ResolveClairExperienceUseCase, 'ResolveClairExperienceUseCase', VOID, VOID, [IResolveClairExperienceUseCase], [0]);
//endregion
function get_earnedWageAccessFeatureModule() {
  _init_properties_EarnedWageAccessFeatureModule_kt__ou94tv();
  return earnedWageAccessFeatureModule;
}
var earnedWageAccessFeatureModule;
function earnedWageAccessFeatureModule$lambda($this$module) {
  _init_properties_EarnedWageAccessFeatureModule_kt__ou94tv();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = earnedWageAccessFeatureModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IResolveClairExperienceUseCase), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  return Unit_instance;
}
function earnedWageAccessFeatureModule$lambda$lambda($this$factory, it) {
  _init_properties_EarnedWageAccessFeatureModule_kt__ou94tv();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(PayAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(IFeatureFlagEvaluator), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$factory.q1d(getKClass(IClairSdkAppKeyProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$3 = $this$factory.q1d(getKClass(IEnvironmentProvider), null, null);
  return new ResolveClairExperienceUseCase(tmp, tmp_0, tmp_1, tmp$ret$3);
}
var properties_initialized_EarnedWageAccessFeatureModule_kt_s34i7l;
function _init_properties_EarnedWageAccessFeatureModule_kt__ou94tv() {
  if (!properties_initialized_EarnedWageAccessFeatureModule_kt_s34i7l) {
    properties_initialized_EarnedWageAccessFeatureModule_kt_s34i7l = true;
    earnedWageAccessFeatureModule = module_0(VOID, earnedWageAccessFeatureModule$lambda);
  }
}
function IResolveClairExperienceUseCase() {
}
function ResolveClairExperienceUseCase(payAccessor, featureFlagEvaluator, clairSdkAppKeyProvider, environmentProvider) {
  this.q8z_1 = payAccessor;
  this.r8z_1 = featureFlagEvaluator;
  this.s8z_1 = clairSdkAppKeyProvider;
  this.t8z_1 = environmentProvider;
}
//region block: exports
export {
  get_earnedWageAccessFeatureModule as get_earnedWageAccessFeatureModule2ejr6u56f80an,
  IResolveClairExperienceUseCase as IResolveClairExperienceUseCase2nel3vlqaxlls,
};
//endregion

